<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content
    *hlmDialogPortal
    class="flex max-h-[90vh] max-w-5xl flex-col gap-4 overflow-hidden sm:max-w-5xl">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Vorlage als Hintergrund</h3>
      <p hlmDialogDescription>
        Die Grafik der Vorlage wird der Hintergrund; deine Elemente bleiben. Die Seite nimmt das
        Format der Vorlage an.
      </p>
    </div>

    <div class="-mx-1 min-h-0 flex-1 overflow-y-auto px-1">
      @if (error(); as message) {
        <div hlmAlert variant="destructive">
          <ng-icon name="lucideTriangleAlert" />
          <p hlmAlertTitle>{{ message }}</p>
          <p hlmAlertDescription>
            <button hlmBtn variant="link" size="sm" type="button" (click)="load()">
              Erneut versuchen
            </button>
          </p>
        </div>
      } @else {
        <app-template-picker
          [templates]="templates()"
          [filterByType]="false"
          [artworkOnly]="true"
          [selectedKey]="selectedKey()"
          [showPreviews]="open()"
          (select)="selectedKey.set($event.key)"
          (uploadBranding)="goToBranding()" />
      }
    </div>

    <div hlmDialogFooter class="shrink-0 border-t pt-4">
      <button hlmBtn variant="outline" type="button" [disabled]="busy()" (click)="close.emit()">
        Abbrechen
      </button>
      <button
        hlmBtn
        type="button"
        [disabled]="!selectedKey() || busy()"
        (click)="choose.emit(selectedKey()!)">
        @if (busy()) {
          <hlm-spinner />
        }
        Als Hintergrund verwenden
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
